'use client';

import type { ComponentType, ReactElement } from 'react';
import { UserMenuInitialTab } from '@/contexts/layout';
import { Ccontainer } from '../Ccontainer';
import type { CusermenuProps } from '../Cusermenu';

interface UserMenuModalContentProps {
  UserMenuComponent: ComponentType<CusermenuProps>;
  initialTab: UserMenuInitialTab;
  onClose: () => void;
  onUnsavedChangesChange: (hasUnsavedChanges: boolean) => void;
}

export function UserMenuModalContent({
  UserMenuComponent,
  initialTab,
  onClose,
  onUnsavedChangesChange,
}: UserMenuModalContentProps): ReactElement {
  return (
    <Ccontainer
      display="flex"
      padding={0}
      style={{
        borderRadius: '2.5rem',
        height: '100%',
      }}
    >
      <UserMenuComponent
        key={initialTab}
        initialTab={initialTab}
        onClose={onClose}
        onUnsavedChangesChange={onUnsavedChangesChange}
      />
    </Ccontainer>
  );
}
